import * as React from 'react';
import { getCurrentRoute, routeInfo, routePrefix } from '../../routeInfo';
import { parseQuery } from '../../services/mini/parseQuery';
import { put, call, takeLatest, takeEvery } from 'redux-saga/effects';
import { push, replace } from 'react-router-redux';
import * as _ from 'lodash';
import * as types from './actionTypes.user';
import * as projectsActionTypes from '../projects/actionTypes.projects';
import * as analyticsActionTypes from '../analytics/actionsTypes.analytics';
import * as projects from '../projects/saga.projects';
import * as errorSaga from '../errors/saga.errors';
import * as confirmSaga from '../confirm/saga.confirm';
import * as gitHubIntegrationSaga from '../gitHubIntegration/saga.gitHubIntegration';
import history from '../../history';
import errorMessages from '../../const/errorMessages';
import errorCodes from '../../const/errorCodes';
import store from '../../store';
import initialState from '../initialState';
import getBaseUrl from '../../services/mini/getBaseUrl';
import Api from '../../api/Api';
import ToasterService from '../../services/ToasterService';
import { clearEncGitHubToken, clearGitHubTokenAndScope, getEncGitHubToken, setEncGitHubToken, setGitHubTokenAndScope } from '../../services/mini/gitHubToken';
import { SHOW_ADD_GITHUB_REPO_URL_POPUP } from '../gitHubIntegration/actionTypes.gitHubIntegration';
import GaService from '../../services/GaService';
import { pages, actions as planActions } from '../../const/plansAnalytics';
import { confirmAlert } from '../../services/mini/alanConfirmAlert';
import ChangePlanPopup from '../../views/pages/plans/ChangePlanPopup/ChangePlanPopup';
import isLocalStorageAvailable from '../../services/mini/isLocalStorageAvailable';
import { IBaseAction, IPromiseParam } from '../base';
import { IPlan } from '../../models/IPlan';
import { getEmailFromUrl } from '../../services/mini/getEmailFromUrl';
import { getHistoryGranularityMsParam } from '../../services/mini/getHistoryGranularityMsParam';
import { ONE_MONTH } from '../../const/periodRanges';
import { HOURS24 } from '../../const/timeRanges';
import { connectAlanTutor } from '../../api/helpers/connectAlanTutor';

export function* watch() {
    yield takeLatest(types.USER_AUTHORIZE_REQ, authorizeUser);
    yield takeLatest<ISignInParam & IBaseAction>(types.SIGN_IN_USER_REQ, signInUser);
    yield takeLatest<ISignUpParam & IBaseAction>(types.SIGN_UP_USER_REQ, signUpUser);
    yield takeLatest(types.USER_LOG_OUT, logOutUser);
    yield takeLatest<IVerifySignUpParam & IBaseAction>(types.VERIFY_USER_SIGN_UP_REQ, verifySignUp);
    yield takeLatest<IPromiseParam & IBaseAction>(types.GET_GITHUB_LOGIN_NAME_REQ, getGithubLoginName);
    yield takeLatest<IPromiseParam & IBaseAction>(types.GET_PROFILE_REQ, getProfile);
    yield takeLatest<IUpdateProfileParam & IBaseAction>(types.UPDATE_PROFILE_REQ, updateProfile);
    yield takeLatest<IChangePasswordParam & IBaseAction>(types.CHANGE_PASSWORD_REQ, changePassword);
    yield takeLatest<IRequestRestorePasswordEmailParam & IBaseAction>(types.REQUEST_PASSWORD_RESTORE_EMAIL_REQ, requestRestorePasswordEmail);
    yield takeLatest<IRestorePasswordParam & IBaseAction>(types.RESTORE_PASSWORD_REQ, restorePassword);
    yield takeLatest<ICheckIfRestoringPasswordAvailableParam & IBaseAction>(types.CHECK_IF_RESTORING_PASSWORD_AVAILABLE_REQ, checkIfRestoringPasswordAvailable);
    yield takeLatest<IPromiseParam & IBaseAction>(types.GET_GOOGLE_OAUTH_URL_REQ, getGoogleOauthUrl);
    yield takeLatest<IGoogleSignUpParam & IBaseAction>(types.GOOGLE_SIGN_UP_REQ, googleSignUp);
    yield takeLatest<IGoogleSignInParam & IBaseAction>(types.GOOGLE_SIGN_IN_REQ, googleSignIn);
    yield takeLatest<IGetGithubOauthUrlParam & IBaseAction>(types.GET_GITHUB_OAUTH_URL_REQ, getGithubOauthUrl);
    yield takeLatest<IGithubSignUpParam & IBaseAction>(types.GITHUB_SIGN_UP_REQ, githubSignUp);
    yield takeLatest<IGithubSignInParam & IBaseAction>(types.GITHUB_SIGN_IN_REQ, githubSignIn);
    yield takeLatest<IAssignGithubSignInParam & IBaseAction>(types.ASSIGN_GITHUB_ACCOUNT_REQ, assignGithubSignIn);
    yield takeLatest(types.GET_PAYMENT_HISTORY_REQ, getPaymentHistory);
    yield takeLatest<IPromiseParam & IBaseAction>(types.GET_GITHUB_PROMO_INFO_REQ, getGithubPromoInfo);
    yield takeLatest(types.GET_USER_BALANCE_REQ, getUserBalance);
    yield takeLatest<IPromiseParam & IBaseAction>(types.GET_PLANS_REQ, getPlans);
    yield takeLatest<IChangePlanParam & IBaseAction>(types.CHANGE_PLAN_REQ, changePlan);
    yield takeLatest(types.GET_USER_PAYMENT_METHODS_REQ, getUserPaymentMethods);
    yield takeLatest<IVerifyPlanParam & IBaseAction>(types.VERIFY_PLAN_REQ, verifyPlan);
    yield takeLatest<IPromiseParam & IBaseAction>(types.RESET_NEXT_PLAN_TRANSITION_REQ, resetNextPlanTransition);
    yield takeLatest<IShowChangePlanPopupParam & IBaseAction>(types.SHOW_CHANGE_PLAN_POPUP, showChangePlanPopup);
    yield takeLatest<ICancelEnterpriseSubscriptionParam & IBaseAction>(types.CANCEL_ENTERPRISE_SUBSCRIPTION_REQ, cancelEnterpriseSubscription);
    yield takeLatest<IPromiseParam & IBaseAction>(types.RESUME_ENTERPRISE_SUBSCRIPTION_REQ, resumeEnterpriseSubscription);
    yield takeEvery(types.REDIRECT_AFTER_GITHUB_OAUTH_ERR_REQ, redirectAfterGithubOauthError);
    yield takeEvery<IInviteFriendParam & IBaseAction>(types.INVITE_FRIENDS_REQ, inviteFriend);
    yield takeEvery<IPromiseParam & IBaseAction>(types.GET_INVITED_FRIENDS_INFO_REQ, getInvitedFriendsInfo);
    yield takeEvery<IPromiseParam & IBaseAction>(types.GET_RESOURCE_USAGE_REQ, getResourceUsage);
}

interface ISignInParam extends IPromiseParam {
    email: string;
    password: string;
}
export function* signInUser({ email, password, resolve, reject }: ISignInParam) {
    try {
        const encGithubToken = getEncGitHubToken(email);
        const userData = yield call(Api.signIn, email, password, encGithubToken);
        yield call(connectAlanTutor, userData);
        saveCredentialsToStorage(userData);
        if (resolve) {
            resolve();
        }
        yield getProfile();
        yield getUserBalance();
        yield projects.getProjects();
        console.info('GO TO: projects after sign in');
        yield put({ type: types.SIGN_IN_USER_OK, user: userData });
        yield put(push(routeInfo.projects.url()));
        yield checkPlanStatusForEnterprisePlanNavigation();
    } catch (errorData) {
        yield put({ type: types.SIGN_IN_USER_ERR });
        if (errorData.error === errorCodes.userNotApproved) {
            yield errorSaga.putError({ msg: email + ' ' + errorMessages[errorCodes.userNotApproved] });
            return;
        } else if (errorData.error === errorCodes.emailNotConfirmed) {
            try {
                const verificationEmailInfoData = yield call(Api.getLastVerificationEmail, email);
                yield put({ type: types.GET_LAST_VERIFICATION_EMAIL_INFO_OK, verificationEmailInfoData: { ...verificationEmailInfoData, showResendPopup: true } });
                return;
            } catch (error2) {
                yield errorSaga.putError(errorData);
            }
        }

        yield errorSaga.putError(errorData);
    }
}

function callAuthorize(userData) {
    return new Promise(async function (resolve, reject) {
        try {
            const status = await connectAlanTutor({ email: userData.email, token: userData.token });
            if (status === 'authorized') {
                resolve(status);
            }
        } catch (error) {
            reject(error);
        }
    });
}

function getMetaInfo() {
    const params = localStorage.getItem('params') || '';
    const campaignName = parseQuery(params)['utm_campaign'] || '';
    return {
        cid: (window.gaTracker && window.gaTracker[0]) ? window.gaTracker[0].get('clientId') : '',
        campaignName: decodeURIComponent(campaignName.replace(/\+/g, ' ')),
        url: params.substr(1, params.length),
        params: JSON.stringify(parseQuery(params))
    };
}

interface ISignUpParam extends IPromiseParam {
    email: string;
    password: string;
    invitationCode?: string;
}
export function* signUpUser({ email, password, invitationCode }: ISignUpParam) {

    try {
        const baseUrl = getBaseUrl();
        clearLocalStorageUserKeys();
        const userData = yield call(Api.signUp, email, password, baseUrl, getMetaInfo(), invitationCode);
        yield put({ type: types.SIGN_UP_USER_OK });
        yield put(push(routeInfo.registered.path));
    } catch (errorData) {
        yield put({ type: types.SIGN_UP_USER_ERR });
        if (errorData.error === errorCodes.userAlreadyExist) {
            yield put(push(routeInfo.login.url()));
            yield errorSaga.putError(errorData);
            return;
        }
        if (errorData.error === errorCodes.userNotApproved) {
            yield errorSaga.putError({ msg: email + ' ' + errorMessages[errorCodes.userNotApproved] });
            return;
        }
        if (errorData.error === errorCodes.verificationEmailSent) {
            ToasterService.showInfo({
                title: 'Verification email has been re-sent. Check your inbox.'
            });
            return;
        }

        yield errorSaga.putError(errorData);
    }
}

interface IVerifySignUpParam extends IPromiseParam {
    email: string;
    hex: string;
}
export function* verifySignUp({ hex, email, resolve, reject }: IVerifySignUpParam) {
    try {
        const userData = yield call(Api.verifySignUp, hex, email);
        GaService.sendSignedUpPageView();
        yield put({ type: types.VERIFY_USER_SIGN_UP_OK });
        yield call(connectAlanTutor, userData);
        saveCredentialsToStorage(userData);
        const { meta, userId } = yield authorizeUser();
        GaService.setUserId(userId);
        GaService.sendFirstLoginEvent({ ...meta, loginType: 'Email' });
        resolve();
    } catch (errorData) {
        yield put({ type: types.VERIFY_USER_SIGN_UP_ERR });
        yield errorSaga.putError(errorData);
        if (errorData.error === errorCodes.userAlreadyExist) {
            yield put(push(routeInfo.login.url()));
            reject();
            return;
        }
        if (errorData.error === errorCodes.userAlreadyVerified) {
            reject();
            return;
        }
        reject();
    }
}


export function* authorizeUser() {
    try {
        var email = localStorage.getItem('alan_email');
        var token = localStorage.getItem('alan_token');
        var currentRoute = getCurrentRoute();

        var goToProjectsAfterLoginRoutes = ['login', '/', '', 'oauth', 'loginWithGithub', 'oops', 'planVerification', 'orgMemberVerification'];
        var userData = {
            email: email,
            token: token
        };

        let profile = {};

        if (email && token) {
            yield call(callAuthorize, userData);
            yield put({ type: types.SIGN_IN_USER_OK, user: userData });
            profile = yield getProfile();
            yield getUserBalance();
            yield projects.getProjects();
            if (goToProjectsAfterLoginRoutes.indexOf(currentRoute) >= 0 || currentRoute.indexOf('login/verify') >= 0) {
                console.info('GO TO: projects after authorize');
                yield put(replace(routeInfo.projects.url()));
            }
            yield put({ type: types.USER_AUTHORIZE_OK, email });
            yield checkPlanStatusForEnterprisePlanNavigation();
        } else {
            yield put({ type: types.USER_AUTHORIZE_ERR });
            if (currentRoute !== 'planVerification' && currentRoute !== routeInfo.login.path) {
                yield put(replace(routeInfo.login.path));
            }
        }

        return { email, ...profile };

    } catch (errorData) {
        if (errorData.error === errorCodes.invalidAuthResponse || errorData.error === errorCodes.unauthorized) {
            yield logOutUser();
            return;
        }
        yield put(replace(routeInfo.login.url()));
        clearLocalStorageUserKeys();

        yield call(connectAlanTutor);

        ToasterService.showInfo({ title: 'Your login session has expired. Please log in again to continue.', onlyUserCanHide: true });
        yield put({ type: types.USER_AUTHORIZE_ERR });
    }
}

export function* logOutUser() {
    try {
        clearLocalStorageUserKeys();
        yield put(push(routeInfo.login.url()));

    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* checkPlanStatusForEnterprisePlanNavigation() {
    const { nextPlanId } = yield call(Api.checkPlanStatus);
    if (nextPlanId) {
        const plans = yield getPlans();
        const nextPlan = _.find(plans, { id: nextPlanId });
        if (nextPlan) {
            yield put(replace(routeInfo.plans.url()));
            yield showChangePlanPopup({ nextPlan, systemEvent: true });
        }
    }
}

function saveCredentialsToStorage(userData) {
    localStorage.setItem('alan_token', userData.token);

    if (userData.email) {
        localStorage.setItem('alan_email', userData.email);
    }

    if (userData.encGithubToken) {
        setEncGitHubToken(userData.email, userData.encGithubToken);
    }
}

function clearLocalStorageUserKeys() {
    localStorage.removeItem('alan_email');
    localStorage.removeItem('alan_token');
    sessionStorage.removeItem('alan_session_id');
    sessionStorage.removeItem('mobile_warning_was_shown');

    for (let i = 0; i < localStorage.length; i++) {
        const tempKey = localStorage.key(i);

        if (tempKey.indexOf('script-draft') > -1 && tempKey.indexOf('alan_enc_github_token') > -1) {
            localStorage.removeItem(tempKey);
        }
    }
}

export function* getProfile({ resolve, reject }: IPromiseParam = {}) {
    try {
        const profile = yield call(Api.getProfile);
        yield getGithubLoginName();
        yield getPlans();
        yield put({
            type: types.GET_PROFILE_OK,
            profile: {
                ...profile,
                campaignName: profile.meta?.campaignName
            }
        });
        if (resolve) {
            resolve(profile);
        }
        return profile;
    } catch (error) {
        if (reject) {
            reject();
        }
        yield errorSaga.putError(error);
    }
}

export function* getGithubLoginName({ resolve, reject }: IPromiseParam = {}) {
    try {
        const encGithubToken = getEncGitHubToken();
        const userToken = localStorage.getItem('alan_token');
        if (userToken && encGithubToken) {
            const githubLogin = yield call(Api.getGithubLoginName, userToken, encGithubToken);
            yield put({ type: types.GET_GITHUB_LOGIN_NAME_OK, githubLogin });
            if (resolve) {
                resolve(githubLogin);
            }
        } else {
            resolve('');
        }
    } catch (error) {
        if (reject) {
            reject();
        }
        yield put({ type: types.GET_GITHUB_LOGIN_NAME_ERR });
    }
}

interface IUpdateProfileParam {
    firstName: string, lastName: string, companyName: string
}

export function* updateProfile({ firstName, lastName, companyName }: IUpdateProfileParam) {
    try {
        yield call(Api.updateProfile, firstName, lastName, companyName);
        const profile = { firstName, lastName, companyName };
        yield put({ type: types.UPDATE_PROFILE_OK, profile });
    } catch (error) {
        yield errorSaga.putError(error);
    }
}
interface IChangePasswordParam extends IPromiseParam {
    email: string, password: string, oldPassword: string
}
export function* changePassword({ email, password, oldPassword, resolve, reject }: IChangePasswordParam) {
    try {
        const encGithubToken = getEncGitHubToken();
        const data = yield call(Api.changePassword, password, oldPassword, encGithubToken);
        saveCredentialsToStorage(data);
        yield authorizeUser();
        resolve();
        yield put({ type: types.CHANGE_PASSWORD_OK });
        yield errorSaga.showInfo('Password was changed.');
    } catch (errorData) {
        reject();
        if (errorData.error === errorCodes.invalidPreviousPassword) {
            ToasterService.showError({
                title: errorMessages[errorCodes.invalidPreviousPassword].replace('restorePassword', `restorePassword\/${email}`)
            });
            return;
        } else {
            yield errorSaga.putError(errorData);
        }
        yield put({ type: types.CHANGE_PASSWORD_ERR });
    }
}

interface IRequestRestorePasswordEmailParam {
    email: string
}
export function* requestRestorePasswordEmail({ email }: IRequestRestorePasswordEmailParam) {
    try {
        var baseUrl = getBaseUrl();
        yield call(Api.sendPasswordRecoveryEmail, email, baseUrl);
        yield put(replace(routeInfo.login.url()));
        yield errorSaga.showInfo('Check your email for a link to reset your password. If it doesn’t appear within a few minutes, check your spam folder.');
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

interface IRestorePasswordParam {
    email: string;
    password: string;
    hex: string;
}
export function* restorePassword({ email, password, hex }: IRestorePasswordParam) {
    try {
        yield call(Api.passwordRecovery, password, hex);
        yield errorSaga.showInfo('Password was changed.');
        yield signInUser({ password, email });
    } catch (errorData) {
        if (errorData.error === errorCodes.passwordAlreadyChanged) {
            ToasterService.showError({
                title: errorMessages[errorCodes.passwordAlreadyChanged].replace('restorePassword', `restorePassword\/${email}`)
            });
            return;
        }
        yield errorSaga.putError(errorData);
    }
}

interface ICheckIfRestoringPasswordAvailableParam extends IPromiseParam {
    email: string;
    hex: string;
}
export function* checkIfRestoringPasswordAvailable({ hex, email, resolve, reject }: ICheckIfRestoringPasswordAvailableParam) {
    try {
        yield call(Api.passwordRecoveryAvailable, hex);
        resolve();
    } catch (errorData) {
        if (errorData.error === errorCodes.passwordAlreadyChanged) {
            yield put(push(routeInfo.restorePassword.url(email)));
            reject();
            yield errorSaga.putError(errorData);
            return;
        }

        yield errorSaga.putError(errorData);
        reject();
    }
}

function getGoogleOauthRedirectUrl(invitationCode?) {
    const { host } = window.location;
    if (invitationCode) {
        return `https://${host}${routePrefix()}/oauth&state=${encodeURI(JSON.stringify({ invitationCode }))}`;
    }
    return `https://${host}${routePrefix()}/oauth`;
}

interface IGetGoogleOauthUrlParam extends IPromiseParam {
    invitationCode?: string;
}

export function* getGoogleOauthUrl({ invitationCode, resolve, reject }: IGetGoogleOauthUrlParam) {
    try {
        const redirectUrl = getGoogleOauthRedirectUrl(invitationCode);
        const { url } = yield call(Api.getGoogleOauthUrl, redirectUrl);
        resolve(url);
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

interface IGoogleSignUpParam extends IPromiseParam {
    code: string;
}
export function* googleSignUp({ code, resolve, reject }: IGoogleSignUpParam) {
    try {
        const redirectUrl = getGoogleOauthRedirectUrl();
        const encGithubToken = getEncGitHubToken();
        const authRes = yield call(Api.googleSignIn, code, redirectUrl, getMetaInfo(), encGithubToken);
        const { email, token, signUp } = authRes;
        saveCredentialsToStorage(authRes);
        const { meta, userId } = yield authorizeUser();
        GaService.setUserId(userId);
        if (signUp) {
            GaService.sendFirstLoginEvent({ ...meta, loginType: 'Google' });
        }
        resolve();
    } catch (error) {
        yield errorSaga.putError(error);
        reject();
    }
}

interface IGoogleSignInParam extends IPromiseParam {
    code: string;
    invitationCode?: string;
}
export function* googleSignIn({ code, invitationCode, resolve, reject }: IGoogleSignInParam) {
    try {
        const redirectUrl = getGoogleOauthRedirectUrl();
        const authRes = yield call(Api.googleSignIn, code, redirectUrl, getMetaInfo(), null, invitationCode);
        const { email, token, signUp } = authRes;
        const encGithubToken = getEncGitHubToken(email);
        saveCredentialsToStorage(authRes);
        const { meta, userId } = yield authorizeUser();
        if (encGithubToken) {
            const { encGithubToken: newEncGithubToken } = yield call(Api.updateGithubToken, encGithubToken);
            if (newEncGithubToken) {
                setEncGitHubToken(email, newEncGithubToken);
            }
        }
        GaService.setUserId(userId);
        if (signUp) {
            GaService.sendFirstLoginEvent({ ...meta, loginType: 'Google' });
        }
        resolve();
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

interface IGetGithubOauthUrlParam extends IPromiseParam {
    action: string;
    repositoryAccess: string;
    invitationCode?: string;
    withUserId?: boolean;
}
export function* getGithubOauthUrl({ action, repositoryAccess, invitationCode, withUserId, resolve, reject }: IGetGithubOauthUrlParam) {
    try {
        // this address is replaced in the build stage task, check it before changing
        let redirectUrl = `https://${process.env.GIT_AUTH_DOMAIN}/${routeInfo.githubOauth.path}`;
        if (action === 'assign') {
            redirectUrl = `${redirectUrl}?action=assign`;
            localStorage.setItem('alanRedirect', history.getCurrentLocation().pathname);
        }
        if (action === 'repo') {
            redirectUrl = `${redirectUrl}?action=repo`;
            localStorage.setItem('alanRedirect', history.getCurrentLocation().pathname);
        }
        if (invitationCode) {
            redirectUrl = redirectUrl + `?invitationCode=` + invitationCode
        }
        let url;
        if (withUserId) {
            url = yield call(Api.getGithubOauthUrlForUser, redirectUrl, repositoryAccess);
        } else {
            url = yield call(Api.getGithubOauthUrl, redirectUrl, repositoryAccess);
        }
        resolve(url);
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

interface IGithubSignUpParam extends IPromiseParam {
    code: string;
}
export function* githubSignUp({ code, resolve, reject }: IGithubSignUpParam) {
    try {
        const authRes = yield call(Api.githubSignIn, code, getMetaInfo());
        const { email, token, signUp } = authRes;
        saveCredentialsToStorage(authRes);
        const { meta, userId } = yield authorizeUser();
        GaService.setUserId(userId);
        if (signUp) {
            GaService.sendFirstLoginEvent({ ...meta, loginType: 'GitHub' });
        }
        resolve();
    } catch (error) {
        yield errorSaga.putError(error);
        reject();
    }
}
interface IGithubSignInParam extends IPromiseParam {
    code: string;
    invitationCode: string;
}
export function* githubSignIn({ code, invitationCode, resolve, reject }: IGithubSignInParam) {
    try {
        const authRes = yield call(Api.githubSignIn, code, getMetaInfo(), invitationCode);
        const { email, token, encGithubToken, signUp } = authRes;
        saveCredentialsToStorage(authRes);
        const { meta, userId } = yield authorizeUser();
        GaService.setUserId(userId);
        if (signUp) {
            GaService.sendFirstLoginEvent({ ...meta, loginType: 'GitHub' });
        }
        resolve();
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

interface IAssignGithubSignInParam {
    code: string;
    repositoryAccess: string;
}
export function* assignGithubSignIn({ code, repositoryAccess }: IAssignGithubSignInParam) {
    try {
        const { email } = yield authorizeUser();
        try {
            const { encGithubToken, githubToken, scope } = yield call(Api.assignGithubAccount, code, repositoryAccess);
            yield saveGithubTokensOnAssign({
                email, encGithubToken, githubToken, scope, repositoryAccess, assignedToEmail: null
            });
        } catch (errorDataForAssign) {
            const { encGithubToken, githubToken, scope, assignedToEmail } = errorDataForAssign;
            if (errorDataForAssign.error === errorCodes.githubAccountAlreadyAssigned) {
                yield saveGithubTokensOnAssign({
                    email, encGithubToken, githubToken, scope, repositoryAccess, assignedToEmail
                });
            } else {
                yield redirectAfterAssigningGithubAccount();
                yield errorSaga.putError(errorDataForAssign);
            }
        }
    } catch (errorData) {
        yield errorSaga.putError(errorData);
    }
}

function* saveGithubTokensOnAssign({ encGithubToken, githubToken, scope, email, repositoryAccess, assignedToEmail }) {
    try {
        if (encGithubToken) {
            setEncGitHubToken(email, encGithubToken);
        }
        if (githubToken) {
            setGitHubTokenAndScope(email, githubToken, scope);
        }

        if (!assignedToEmail && repositoryAccess) {
            localStorage.setItem(SHOW_ADD_GITHUB_REPO_URL_POPUP, true.toString());
        }
        if (assignedToEmail) {
            const { okBtnAction, cancelBtnAction } = yield confirmSaga.confirm({
                title: 'Warning',
                message: `This GitHub account is already assigned to the Alan AI Studio account <b>${assignedToEmail}</b>. Do you want to re-assign it to the current account <b>${email}</b>?`,
                okBtnLabel: `Re-assign`,
            });

            if (okBtnAction) {
                if (repositoryAccess) {
                    localStorage.setItem(SHOW_ADD_GITHUB_REPO_URL_POPUP, true.toString());
                }
                yield call(Api.reassignGithubAccount, encGithubToken);
            }
            if (cancelBtnAction) {
                clearEncGitHubToken();
                clearGitHubTokenAndScope();
            }
        }

        yield getGithubLoginName();
        yield redirectAfterAssigningGithubAccount(repositoryAccess);
    } catch (errorData) {
        yield errorSaga.putError(errorData);
    }
}

function* redirectAfterAssigningGithubAccount(hideAssignMsg?) {
    const redirectUrl = localStorage.getItem('alanRedirect');
    const { githubLogin, email } = yield getProfile();
    if (redirectUrl) {
        localStorage.removeItem('alanRedirect');
        yield put(replace(redirectUrl));
        if (githubLogin && email && hideAssignMsg !== true) {
            ToasterService.showInfo({
                title: `Your Github account <b>${githubLogin}</b> was assigned to the current account <b>${email}</b>`
            });
        }
    }
}

export function* getUserBalance() {
    try {
        const balance = yield call(Api.getUserBalanceInfo);
        yield put({ type: types.GET_USER_BALANCE_OK, balance });
        return balance;
    } catch (errorData) {
        if (errorData.error === errorCodes.balanceNotExists) {
            yield put({
                type: types.GET_USER_BALANCE_OK,
                balance: {
                    balanceMoney: initialState.user.balance,
                    balanceFreeInteractions: initialState.user.freeInteractions,
                    hasAssignedCard: initialState.user.hasAssignedCard,
                    allowedToWork: initialState.user.allowedToWork,
                    capabilities: initialState.user.capabilities,
                    tier: initialState.user.tier,
                }
            });
            return;
        }

        yield errorSaga.putError(errorData, true);
    }
}


export function* getPaymentHistory() {
    try {
        const payments = yield call(Api.getPaymentHistory);
        yield put({ type: types.GET_PAYMENT_HISTORY_OK, payments });
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* getGithubPromoInfo({ resolve, reject }: IPromiseParam = {}) {
    try {
        const savedEmail = localStorage.getItem('alan_email');
        if (!savedEmail) return;
        const encGithubToken = getEncGitHubToken();
        let info = {};
        if (encGithubToken) {
            info = yield call(Api.getGithubPromoInfo, encGithubToken);
            yield put({ type: types.GET_GITHUB_PROMO_INFO_OK, info });
        }
        yield getUserBalance();
        if (resolve) {
            resolve(info);
        }
    } catch (errorData) {
        if (errorData.error === errorCodes.undefinedGithubToken ||
            errorData.error === errorCodes.invalidGithubToken ||
            errorData.error === errorCodes.noGithubLogin) {
            if (errorData.error === errorCodes.undefinedGithubToken ||
                errorData.error === errorCodes.invalidGithubToken) {
                clearEncGitHubToken();
            }
            yield gitHubIntegrationSaga.handleGithubIntegrationErrors(errorData);
        } else {
            yield errorSaga.putError(errorData);
        }

        yield put({ type: types.GET_GITHUB_PROMO_INFO_ERR });

        if (reject) {
            reject();
        }
    }
}

export function* getPlans({ resolve, reject }: IPromiseParam = {}) {
    try {
        let plans = yield call(Api.getUserPlans);
        yield getGithubLoginName();
        yield getGithubPromoInfo();
        plans = plans.map(plan => ({ ...plan, isUserSpecificPlan: true }));
        const hasEnterprisePlans = !!plans.length;
        if (!hasEnterprisePlans) {
            plans = yield call(Api.getPlans);
        }
        const balance = yield getUserBalance();
        yield getUserPaymentMethods();
        const currentPlan = _.find(plans, { id: balance.planId });
        yield put({ type: types.GET_PLANS_OK, plans, currentPlan });
        if (resolve) {
            resolve(plans);
        }
        return plans;
    } catch (error) {
        yield errorSaga.putError(error);
        if (reject) {
            reject();
        }
    }
}
interface IChangePlanParam extends IPromiseParam {
    planId: string;
    paymentId: string;
    paymentType: string;
    onlyCheck: boolean;
}
export function* changePlan({ planId, paymentId, paymentType, onlyCheck, resolve, reject }: IChangePlanParam) {
    try {
        const changePlanData = yield call(Api.changePlan, planId, paymentId, paymentType, onlyCheck);
        yield getPlans();
        resolve({
            ...changePlanData,
            refundAmount: +changePlanData.refundAmount / 100,
            balanceAfterChange: +changePlanData.balanceAfterChange / 100
        });
    } catch (errorData) {
        reject(errorData);
    }
}

export function* getUserPaymentMethods() {
    try {
        const cards = yield call(Api.getUserPaymentMethods);
        yield put({ type: types.GET_USER_PAYMENT_METHODS_OK, cards });
    } catch (errorData) {
        yield errorSaga.putError(errorData);
    }
}

interface IVerifyPlanParam extends IPromiseParam {
    code: string;
}
export function* verifyPlan({ code, resolve, reject }: IVerifyPlanParam) {
    const emailFromUrl = getEmailFromUrl();
    try {

        store.dispatch({
            type: analyticsActionTypes.TRACK_PLAN_ACTION_REQ,
            page: pages.plans,
            action: planActions.confirmPlan,
            code
        });

        const savedEmail = localStorage.getItem('alan_email');
        if (savedEmail && emailFromUrl && savedEmail.toLowerCase() === emailFromUrl.toLowerCase()) {
            yield authorizeUser();
            yield call(Api.verifyPlan, code);
        } else {
            yield put(push(routeInfo.registerWithEmail.url(emailFromUrl)));
            yield call(Api.verifyPlan, code);
        }
        ToasterService.showInfo({ title: 'Your individual Enterprise plan was approved' });
    } catch (errorData) {
        if (errorData.error === errorCodes.userNotFound) {
            yield put(push(routeInfo.registerWithEmail.url(emailFromUrl)));
            ToasterService.showInfo({ title: 'Your individual Enterprise plan was approved, please register your user to start using it' });
        } else {
            yield errorSaga.putError(errorData);
        }
        if (reject) {
            reject();
        }
    }
}

export function* resetNextPlanTransition({ resolve, reject }: IPromiseParam) {
    try {
        if (isLocalStorageAvailable()) {
            const email = localStorage.getItem('alan_email');
            const resetCount = +localStorage.getItem(`alan-reset-plan-transition-${email}`) || 0;
            if (resetCount < 2) {
                localStorage.setItem(`alan-reset-plan-transition-${email}`, (resetCount + 1).toString());
                return;
            } else {
                localStorage.removeItem(`alan-reset-plan-transition-${email}`);
            }
        }
        yield call(Api.resetNextPlanTransition);
    } catch (errorData) {
        if (reject) {
            reject();
        }
        yield errorSaga.putError(errorData);
    }
}

interface IShowChangePlanPopupParam {
    nextPlan: IPlan;
    systemEvent: boolean;
}
export function* showChangePlanPopup({ nextPlan, systemEvent }: IShowChangePlanPopupParam) {
    try {
        store.dispatch({
            type: analyticsActionTypes.TRACK_PLAN_ACTION_REQ,
            page: pages.plans,
            action: systemEvent ? planActions.openPlanBySystem : planActions.openPlanByUser,
            newPlanId: nextPlan.id,
            newPlanName: nextPlan.name
        });

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <ChangePlanPopup
                        onClose={() => {
                            store.dispatch({
                                type: analyticsActionTypes.TRACK_PLAN_ACTION_REQ,
                                page: pages.plans,
                                action: planActions.closePlan
                            });
                            onClose();
                        }
                        }
                        onBillingPopupClosed={(nextPlanInCb) => {
                            store.dispatch({
                                type: types.SHOW_CHANGE_PLAN_POPUP,
                                nextPlan: nextPlanInCb,
                            });
                        }}
                        store={store}
                        nextPlan={nextPlan}
                    />
                );
            }
        });
    } catch (errorData) {
        yield errorSaga.putError(errorData);
    }
}

interface ICancelEnterpriseSubscriptionParam extends IPromiseParam {
    planId: string;
}
export function* cancelEnterpriseSubscription({ planId, resolve, reject }: ICancelEnterpriseSubscriptionParam) {
    try {
        yield call(Api.cancelEnterpriseSubscription, planId);
        yield getPlans();
        ToasterService.showInfo({ title: 'Your subscription has been cancelled, and you will not be charged again. The cancellation is pending until what would otherwise be your renewal date. At that date the cancellation becomes final.' });
    } catch (errorData) {
        yield errorSaga.putError(errorData);
        if (reject) {
            reject();
        }
    }
}

export function* resumeEnterpriseSubscription({ resolve, reject }: IPromiseParam) {
    try {
        yield call(Api.resumeEnterpriseSubscription);
        yield getPlans();
        ToasterService.showInfo({ title: 'Your subscription has been resumed. You will be charged again in the next payment period.' });
    } catch (errorData) {
        yield errorSaga.putError(errorData);
    }
}
export interface IInviteFriendParam extends IPromiseParam {
    email: string;
}
export function* inviteFriend({ email, resolve, reject }: IInviteFriendParam) {
    try {
        yield call(Api.inviteFriend, email);
        yield getInvitedFriendsInfo();
        resolve();
    }
    catch (errorData) {
        reject();
        if (errorData.error === errorCodes.userAlreadyExist) {
            ToasterService.showError({
                title: "This user already has an account in Alan AI Studio",
            });
        } else if (errorData.error === errorCodes.invitationEmailWasResent) {
            ToasterService.showWarning({
                title: errorMessages[errorCodes.invitationEmailWasResent],
            });
        } else {
            yield errorSaga.putError(errorData);
        }
    }
}

export function* getInvitedFriendsInfo({ resolve, reject }: IPromiseParam = {}) {
    try {
        const { invitedFriends, earnedFreeInteractionsPerMonth } = yield call(Api.getInvitedFriendsInfo);
        yield put({ type: types.GET_INVITED_FRIENDS_INFO_OK, invitedFriends, earnedFreeInteractionsPerMonth });
        if (resolve) {
            resolve(invitedFriends);
        }
    }
    catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* redirectAfterGithubOauthError() {
    try {
        yield authorizeUser();
        yield redirectAfterAssigningGithubAccount(true);
    }
    catch (error) {
        yield errorSaga.putError(error);
    }
}


export function* getResourceUsage({ resolve, reject }: IPromiseParam = {}) {
    try {
        const toTs = Date.now();
        const fromTs = toTs - 30 * HOURS24;
        const historyGranularityMs = getHistoryGranularityMsParam(ONE_MONTH);


        const { data: consumptions } = yield call(Api.getResourceUsage, { fromTs, toTs, historyGranularityMs, type: 0 });

        // console.log(consumptions);
        if (resolve) {
            resolve(consumptions);
        }
    }
    catch (error) {
        yield errorSaga.putError(error);
    }
}
